/**
 * Translations for shared 3D / Pixi scene labels.
 * Used by HabitatScene3D, HabitatScene (Pixi) and ZooScene.
 */
const scene = {
  zh: {
    // Species (used in Pixi ZooScene errors)
    'scene.species.hamster': '仓鼠',
    'scene.species.rabbit': '兔兔',
    'scene.species.dog': '狗狗',
    'scene.species.dragon': '龙龙',

    // Day phase (3D + Pixi habitat)
    'scene.phase.morning': '清晨',
    'scene.phase.day': '白天',
    'scene.phase.sunset': '黄昏',
    'scene.phase.night': '夜晚',

    // Weather (3D + Pixi habitat)
    'scene.weather.sunny': '晴朗',
    'scene.weather.cloudy': '多云',
    'scene.weather.rainy': '细雨',

    // Pixi ZooScene weather/period (slightly different keys/wording)
    'scene.zoo.weather.clear': '晴天',
    'scene.zoo.weather.cloudy': '多云',
    'scene.zoo.weather.rain': '下雨',
    'scene.zoo.period.day': '白天',
    'scene.zoo.period.dusk': '黄昏',
    'scene.zoo.period.night': '夜晚',

    // 3D scene reaction labels
    'scene.reaction.pet': '贴近伙伴',
    'scene.reaction.ball': '追球冲刺',
    'scene.reaction.swing': '秋千飞起来',
    'scene.reaction.water': '洗澡转圈',
    'scene.reaction.butterfly': '发现小奇迹',

    // 3D HUD chrome
    'scene.badge.3d': '3D 互动乐园',
    'scene.aria.actionRail': '3D 场景快捷互动',
    'scene.action.pet': '摸摸',
    'scene.action.ball': '追球',
    'scene.action.swing': '秋千',
    'scene.action.water': '洗澡',
    'scene.action.butterfly': '蝴蝶',
    'scene.camera.reset': '复位',
    'scene.tip.3d': '拖动抚摸宠物，点击道具会推进镜头',

    // Pixi ZooScene messages / buttons
    'scene.zoo.error.speciesMismatch': '这个建筑不支持 {species}',
    'scene.zoo.error.buildingFull': '这个建筑已经住满了',
    'scene.zoo.error.alreadyHome': '{name} 已经住在这个建筑了',
    'scene.zoo.error.assignFailed': '分配失败，请稍后再试',
    'scene.zoo.action.buyLand': '买地',
    'scene.zoo.action.build': '盖建筑',
    'scene.zoo.action.breeding': '繁育',
    'scene.zoo.label.buildings': '建筑 {built}/{cap}',
    'scene.zoo.hint.dragPet': '把宠物拖到建筑上分配家',
  } as Record<string, string>,
  en: {
    // Species
    'scene.species.hamster': 'Hamster',
    'scene.species.rabbit': 'Rabbit',
    'scene.species.dog': 'Dog',
    'scene.species.dragon': 'Dragon',

    // Day phase
    'scene.phase.morning': 'Morning',
    'scene.phase.day': 'Day',
    'scene.phase.sunset': 'Sunset',
    'scene.phase.night': 'Night',

    // Weather
    'scene.weather.sunny': 'Sunny',
    'scene.weather.cloudy': 'Cloudy',
    'scene.weather.rainy': 'Drizzle',

    // Pixi ZooScene weather/period
    'scene.zoo.weather.clear': 'Clear',
    'scene.zoo.weather.cloudy': 'Cloudy',
    'scene.zoo.weather.rain': 'Rainy',
    'scene.zoo.period.day': 'Day',
    'scene.zoo.period.dusk': 'Dusk',
    'scene.zoo.period.night': 'Night',

    // 3D scene reaction labels
    'scene.reaction.pet': 'Snuggle up',
    'scene.reaction.ball': 'Chase the ball',
    'scene.reaction.swing': 'Swing high',
    'scene.reaction.water': 'Bath twirl',
    'scene.reaction.butterfly': 'Spot a wonder',

    // 3D HUD chrome
    'scene.badge.3d': '3D playground',
    'scene.aria.actionRail': '3D scene quick actions',
    'scene.action.pet': 'Pet',
    'scene.action.ball': 'Ball',
    'scene.action.swing': 'Swing',
    'scene.action.water': 'Bath',
    'scene.action.butterfly': 'Butterfly',
    'scene.camera.reset': 'Reset',
    'scene.tip.3d': 'Drag to stroke the pet, tap a prop to zoom in',

    // Pixi ZooScene messages / buttons
    'scene.zoo.error.speciesMismatch': "This building doesn't allow {species}",
    'scene.zoo.error.buildingFull': 'This building is already full',
    'scene.zoo.error.alreadyHome': '{name} already lives here',
    'scene.zoo.error.assignFailed': 'Could not assign — try again soon',
    'scene.zoo.action.buyLand': 'Buy land',
    'scene.zoo.action.build': 'Build',
    'scene.zoo.action.breeding': 'Breed',
    'scene.zoo.label.buildings': 'Buildings {built}/{cap}',
    'scene.zoo.hint.dragPet': 'Drag a pet onto a building to assign a home',
  } as Record<string, string>,
};

export default scene;
